<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName + "-" + this.route.menuName }}</span>
      </div>
      <div>
        <div class="box" v-for="(item, index) in dataList" :key="index">
          <span>{{ item.name }} :</span>
          <!-- 根据valueType控制第一个checkbox -->
          <el-checkbox :checked="isChecked(item.value)" @change="(val) => controlType(val, item, index)"
            label="0">是否显示</el-checkbox>
          <!-- 根据valueType控制第二个checkbox -->
          <el-checkbox v-model="item.isRequired" :disabled="item.isRequiredDisabled"
            @change="(val) => controlType1(val, item, index)" label="1">是否必填</el-checkbox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import { GetTableSets, SaveTableSets } from "@/api";

export default {
  mixins: [GetDataMixin],
  data() {
    return {
      dataList: []
    };
  },
  methods: {
    getList() {
      GetTableSets({ tableCode: this.$route.name }).then((res) => {
        if (res && res.returnData) {
          this.dataList = res.returnData.data.map(item => ({
            ...item,
            isRequiredDisabled: !this.isChecked(item.value), // 初始化复选框的禁用状态，如果“是否显示”为选中，则不禁用
            isRequired: item.value && item.valueType === 1 // 初始化“是否必填”的状态
          }));
          console.log("this.dataList", this.dataList);
          console.log("value", res.returnData);
        }
      });
    },
    isChecked(value) {
      return value === 'true'; // 将字符串转换为布尔值
    },
    controlType(val, row, index) {
      // 更新value的值
      this.dataList[index].value = val.toString();
      console.log("data", this.dataList)
      // 如果“是否显示”未选中，则将valueType改为0，且“是否必填”为false
      if (!val) {
        this.dataList[index].valueType = 0;
        this.dataList[index].isRequired = false;
      } else {
        // 如果“是否显示”选中，根据“是否必填”的状态来设置valueType
        this.dataList[index].valueType = this.dataList[index].isRequired ? 1 : 0;
      }

      SaveTableSets(row).then(res => {
        console.log(res);
        // 更新复选框的禁用状态
        this.dataList[index].isRequiredDisabled = !val;
      });
    },
    controlType1(val, row, index) {
      // 更新value的值
      this.dataList[index].value = val.toString();
      console.log("data", this.dataList)

      // 如果选中了“是否必填”，则将valueType改为1
      if (this.dataList[index].isRequired) {
        console.log("必填")
        this.dataList[index].valueType = 1;
      } else {
        // 如果“是否必填”未选中，则将valueType改为0
        this.dataList[index].valueType = 0;
        this.dataList[index].value = "true"
      }

      SaveTableSets(row).then(res => {
        console.log("SaveTableSets:",res);
        if (val) {
          this.dataList[index].isRequiredDisabled = false; // 启用复选框
        } 
        // else {
        //   this.dataList[index].isRequiredDisabled = true; // 禁用复选框
        //   this.dataList[index].isRequired = false; // 当“是否显示”未选中时，将“是否必填”改为未选中
        // }
      });
    }

  },
  created() {
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
.box {
  margin: 10px 0;

  span {
    padding-right: 30px;
  }
}
</style>